import { Button, Card, Col, Form, Input, Typography, Space } from "antd";
import { Fragment, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  addDesignation,
  loadAllDesignation,
} from "../../redux/rtk/features/designation/designationSlice";
import UploadMany from "../Card/UploadMany";
import styles from "./AddDesignation.module.css";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";

const AddDesignation = ({ form, isEditMode, setIsEditMode, currentDesignationId, setCurrentDesignationId }) => {
  const dispatch = useDispatch();
  const { Title } = Typography;

  const [loader, setLoader] = useState(false);

  const onFinish = async (values) => {
    setLoader(true);
    try {
      // Fallback to 0 if currentDesignationId is undefined
      const designationIdToUse = isEditMode ? (currentDesignationId ?? 0) : 0;

      const designationData = {
        DesignationId: designationIdToUse,
        DesignationName: values.name,
        DataStatus: 1,
      };

      // console.log("Sending designationData:", designationData); // Log the payload for debugging

      const resp = await dispatch(addDesignation(designationData));

      if (resp.payload.message === "success") {
        setLoader(false);
        form.resetFields();
        setIsEditMode(false);
        setCurrentDesignationId(0);
        dispatch(loadAllDesignation());
        toast.success(
          isEditMode
            ? "Designation updated successfully!"
            : "Designation added successfully!"
        );
      } else {
        setLoader(false);
        toast.error(
          isEditMode ? "Failed to update designation" : "Failed to add designation"
        );
      }
    } catch (error) {
      // console.error("Error in onFinish:", error);
      setLoader(false);
      toast.error(
        isEditMode ? "Failed to update designation" : "Failed to add designation"
      );
    }
  };

  const onFinishFailed = ({ errorFields }) => {
    setLoader(false);
    const errorMessages = errorFields
      .map((field) => field.errors.join(", "))
      .join("; ");
    toast.warning(`Please fix the following errors: ${errorMessages}`);
  };

  const handleReset = () => {
    form.resetFields();
    setIsEditMode(false);
    setCurrentDesignationId(0);
  };

  // Debug: Log the props to ensure they're received correctly
  // console.log("AddDesignation props:", { form, isEditMode, currentDesignationId });

  return (
    <Fragment>
      <Card bordered={false} className="add-designation-form-card">
        <Title level={4} className="text-center">
          {isEditMode ? "Edit Designation" : "Add Designation"}
        </Title>
        <Form
          form={form}
          name="basic"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 12 }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            style={{ marginBottom: "20px" }}
            label={<span className="required-label">Name</span>}
            name="name"
            rules={[
              { required: true, message: "Please input designation name!" },
            ]}
          >
            <Input placeholder="e.g., Test" />
          </Form.Item>

          <Form.Item
            style={{ marginBottom: "20px" }}
            wrapperCol={{ offset: 6, span: 12 }}
          >
            <Space>
              <Button
                type="primary"
                block
                htmlType="submit"
                shape="round"
                size="large"
                loading={loader}
              >
                {isEditMode ? "Update Designation" : "Add Designation"}
              </Button>
              {isEditMode && (
                <Button size="large" onClick={handleReset}>
                  Cancel
                </Button>
              )}
            </Space>
          </Form.Item>
        </Form>
      </Card>
    </Fragment>
  );
};

export default AddDesignation;